var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.7244H17.9986C17.9986 16.7264 18 16.7294 18 16.7324C18 17.9848 15.3137 19 12.0005 19C8.68631 19 6 17.9848 6 16.7324C6 16.7294 6.00093 16.7264 6.00093 16.7244H6V14.5959C6 15.8487 8.68631 16.864 12.0005 16.864C15.3142 16.864 18 15.8487 18 14.5959V16.7244ZM18 13.5476H17.9986C17.9986 13.5501 18 13.5531 18 13.5561C18 14.8085 15.3137 15.8237 12.0005 15.8237C8.68631 15.8237 6 14.8085 6 13.5561C6 13.5531 6.00093 13.5501 6.00093 13.5476H6V11.4196C6 12.6725 8.68631 13.6877 12.0005 13.6877C15.3142 13.6877 18 12.6725 18 11.4196V13.5476ZM18 10.3713H17.9986C17.9986 10.3733 18 10.3763 18 10.3793C18 11.6317 15.3137 12.647 12.0005 12.647C8.68631 12.647 6 11.6317 6 10.3793C6 10.3763 6.00093 10.3733 6.00093 10.3713H6V8.24282C6 9.49571 8.68631 10.5109 12.0005 10.5109C15.3142 10.5109 18 9.49571 18 8.24282V10.3713ZM12.0005 9.53624C8.68631 9.53624 6 8.52051 6 7.26762C6 6.01523 8.68631 5 12.0005 5C15.3142 5 18 6.01523 18 7.26762C18 8.52051 15.3137 9.53624 12.0005 9.53624Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenIcon);
export default __webpack_public_path__ + "static/media/tokenIcon.adc41df27aa57806edb26f20f81fbccd.svg";
export { ForwardRef as ReactComponent };